<template>
  <div class="py-[12px] flex border-b border-osn-grey-03 cursor-pointer
  pc:border-t pc:hover:bg-[#FFDF8D4D]
  mobile:flex-wrap"
       :class="{'bg-[#FFDF8D4D]':spaceInfo.space_id.toString()===routeSid}"
       @click="clickSpace(spaceInfo.space_id)"
       @mouseenter="hoverSpace(spaceInfo.space_id)"
       @mouseleave="leaveSpace">
    <div class="pc:w-[45%] pc:pl-[12px] mobile:w-full flex items-center">
      <img class="aspect-[1024/683] pc:rounded-xl mobile:rounded-3xl"
           :src="picUrl+spaceInfo.photo_url"
           :alt="spaceInfo.photo_description?spaceInfo.photo_description:spaceInfo.space_name"/>
    </div>
    <div class="pc:w-[55%] mobile:w-full pc:px-[12px]">
<!--      <h3 class="mobile:mt-[6px] text-osn-grey-01 text-[12px]">{{ spaceInfo.brand_name }}</h3>-->
      <div class="mobile:mb-[4px] text-[14px] font-bold text-osn-dark-grey-00">{{ spaceInfo.space_name }}</div>
      <div class="tag-wrap">

        <ul>
          <li class="usage"
              v-for="item in spaceInfo.categories[usageCategoryId]">{{ item.name }}
          </li>
<!--          <li class="type"
              v-for="item in spaceInfo.categories[typeCategoryId]">{{ item.name }}
          </li>
          <li class="tag"
              v-for="item in spaceInfo.categories[tagCategoryId]">{{ item.name }}
          </li>-->
        </ul>
      </div>
      <div class="pc:h-[21px] flex items-center text-[14px]"
           :class="spaceInfo.traffics.length>0?'mobile:mt-3':''">
        <svg-icon v-if="spaceInfo.traffics.length>0"
                  class="mr-[5px]"
                  name="mrt"
                  size="20"></svg-icon>
        <span v-if="spaceInfo.traffics.length>0">{{ `${spaceInfo.traffics[0]?.mrt_station} ${spaceInfo.traffics[0]?.mrt_exit} 號出口 `}}</span>
        <span v-if="spaceInfo.traffics.length>0"
              class="ml-[3px] text-osn-grey-01">{{
            $t('space.walking_time', {t: spaceInfo.traffics[0]?.walking_time})
          }}</span>
      </div>
      <div class="mt-2 flex items-center text-[14px]">
        <svg-icon class="mr-[5px]"
                  name="location"
                  size="20"></svg-icon>
        <span>{{ spaceInfo.city + spaceInfo.region + spaceInfo.address }}</span>
      </div>
      <div class="mt-2 px-[8px] flex justify-between items-center">
        <div class="mr-[8px] font-semibold text-[16px]">
          <span class="mr-[5px]">{{ parseFormatCheapestRentPrice(spaceInfo.rent.rent_groups,searchRentType.toString()) }}</span>
          <span class="font-normal text-osn-grey-01 text-[14px]">{{
              `/${searchRentType!==RentType.DAY?parseFormatCheapestRentType(spaceInfo.rent.rent_groups):RentTypeUnits[RentType.DAY]}`
            }}</span>
        </div>
        <div class="text-osn-grey-01 text-[14px] inline-flex items-center">
          <svg-icon class="mr-[4px]"
                    name="people"
                    size="16"></svg-icon>
          {{ spaceInfo.number_of_people_max + '人' }}
        </div>
      </div>
    </div>
  </div>

</template>
<script setup>

import {computed, defineProps} from "vue";
import {useRoute, useRouter} from "nuxt/app";
import {useSettingStore} from "~/stores/setting.js";
import {useGoTo} from "@/composables/useGoTo";
import {parseFormatCheapestRentPrice, parseFormatCheapestRentType} from "~/utils/newPriceTool.ts";
import {RentType,RentTypeUnits} from "~/utils/enums/RentType.ts";

const router = useRouter()
const route = useRoute();
const settingStore = useSettingStore()
const {goToSpacePage} = useGoTo()

const picUrl = import.meta.env.VITE_APP_BASE_IMG_URL
const typeCategoryId = import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID
const tagCategoryId = import.meta.env.VITE_APP_BASE_TAG_CATEGORY_ID
const usageCategoryId = import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID

const routeSid = computed(() => route.query.msid)
const isMobile = computed(() => settingStore.isMobile);

const props = defineProps({
  spaceInfo: {
    type: Object
  },
  searchRentType: {
    type: Number
  }
})

function clickSpace(spaceId) {
  goToSpacePage(spaceId)
}

function hoverSpace(spaceId) {
  if (isMobile.value) {
    return
  }
  router.replace({query: {...route.query, 'msid': spaceId}})

}

function leaveSpace() {
  // console.log('Mouse left the space');

}
</script>
<style scoped
       lang="scss">

.tag-wrap {
  ul {
    @apply flex flex-wrap;
    li {
      @apply w-auto h-[23px] mr-[2px] mb-[2px] px-[6px] py-[2px] bg-osn-yellow-00 rounded-md;
    }

    li.type {
      @apply bg-osn-yellow-04 text-[11px] py-[4px];
    }

    li.tag {
      @apply bg-osn-yellow-05 text-[11px] py-[4px];
    }

  }
}


</style>
